// extracted by mini-css-extract-plugin
export default {"dark":"RulesPassword_dark__Ks1kM","App":"RulesPassword_App__2J31C","rules_password":"RulesPassword_rules_password__Dj06W","title_rules":"RulesPassword_title_rules__GMaXG"};